export default "__VITE_ASSET__PhmHJm$f__"